// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  height: 100%;
}

.product-card {
  border: 1px solid #000000;
  border-radius: 24px;
  background: #ffffff;
  padding: 20px;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  transition: all 0.2s ease-in-out;
  min-height: 450px;
}
.product-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.info-icon-wrapper {
  position: absolute;
  top: 15px;
  right: 15px;
  z-index: 10;
  cursor: pointer;
}
.info-icon-wrapper ion-icon {
  font-size: 24px;
  color: #666666;
}

.image-section {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 5px;
  cursor: pointer;
  aspect-ratio: 9/8;
  width: 60%;
  height: 100%;
  max-width: 227px;
  place-self: center;
}
.image-section .product-img {
  height: 100%;
  width: 100%;
  object-fit: contain;
}
.image-section .placeholder {
  height: 90%;
  width: 90%;
  opacity: 0.8;
}

.content-section {
  text-align: center;
  margin-bottom: 15px;
}
.content-section .product-title {
  font-family: AppFontMedium;
  font-size: 24px;
  leading-trim: NONE;
  line-height: 120%;
  letter-spacing: 0.04em;
  text-align: center;
  vertical-align: middle;
  text-transform: uppercase;
  margin-bottom: 12px;
}
.content-section .product-description {
  font-family: AppFontAlt;
  font-size: 15px;
  leading-trim: NONE;
  line-height: 150%;
  letter-spacing: 0;
  text-align: center;
  vertical-align: middle;
  margin-bottom: 12px;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.meta-row {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 15px;
  font-family: AppFontBold, sans-serif;
  font-size: 14px;
  text-transform: uppercase;
  color: #000000;
  margin-bottom: 12px;
}
.meta-row .price {
  font-family: AppFontSemiBold;
  font-size: 16px;
  leading-trim: NONE;
  line-height: 120%;
  letter-spacing: 0;
  text-align: center;
  vertical-align: middle;
  text-transform: uppercase;
}
.meta-row .divider {
  color: #ccc;
  font-weight: normal;
}
.meta-row .icons {
  display: flex;
  gap: 5px;
  align-items: center;
}
.meta-row .icons ion-icon {
  font-size: 16px;
}

.action-buttons {
  display: flex;
  gap: 12px;
  margin-top: auto;
}
.action-buttons ion-button {
  flex: 1;
  height: 40px;
  --border-radius: 50px;
  --box-shadow: none;
  margin: 0;
  font-family: AppFontSemiBold;
  font-size: 16px;
  leading-trim: NONE;
  line-height: 120%;
  letter-spacing: 0.04em;
  text-align: center;
  vertical-align: middle;
  text-transform: uppercase;
}
.action-buttons ion-button.btn-add {
  --background: var(--ion-color-primary); /* Gold */
  --background-hover: var(--ion-color-primary-shade);
  --color: #ffffff;
}
.action-buttons ion-button.btn-customize {
  --background: transparent;
  --color: #000000;
  --border-color: #333333;
  --border-width: 1px;
  --border-style: solid;
  border-radius: 50px;
}

.kcal {
  color: #666666;
}`, "",{"version":3,"sources":["webpack://./src/app/components/item-view/item-view.component.scss"],"names":[],"mappings":"AAEA;EACC,cAAA;EACA,YAAA;AADD;;AAIA;EACC,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,gCAAA;EACA,iBAAA;AADD;AAEC;EACC,0CAAA;AAAF;;AAIA;EACC,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,eAAA;AADD;AAGC;EACC,eAAA;EACA,cAAA;AADF;;AAKA;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;AAFD;AAIC;EACC,YAAA;EACA,WAAA;EACA,mBAAA;AAFF;AAKC;EACC,WAAA;EACA,UAAA;EACA,YAAA;AAHF;;AAOA;EACC,kBAAA;EACA,mBAAA;AAJD;AAMC;EACC,0BAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;EACA,mBAAA;AAJF;AAOC;EACC,uBAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EAEA,mBAAA;EAEA,oBAAA;EACA,qBAAA;EACA,aAAA;EACA,4BAAA;EACA,gBAAA;AAPF;;AAWA;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,oCAAA;EACA,eAAA;EACA,yBAAA;EACA,cAAA;EACA,mBAAA;AARD;AAUC;EACC,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;AARF;AAWC;EACC,WAAA;EACA,mBAAA;AATF;AAYC;EACC,aAAA;EACA,QAAA;EACA,mBAAA;AAVF;AAYE;EACC,eAAA;AAVH;;AAeA;EACC,aAAA;EACA,SAAA;EACA,gBAAA;AAZD;AAcC;EACC,OAAA;EACA,YAAA;EAEA,qBAAA;EACA,kBAAA;EACA,SAAA;EAEA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;AAdF;AAgBE;EACC,sCAAA,EAAA,SAAA;EACA,kDAAA;EACA,gBAAA;AAdH;AAiBE;EACC,yBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;AAfH;;AAmBA;EACC,cAAA;AAhBD","sourcesContent":["@import '../../../theme/mixins';\n\n:host {\n\tdisplay: block;\n\theight: 100%;\n}\n\n.product-card {\n\tborder: 1px solid #000000;\n\tborder-radius: 24px;\n\tbackground: #ffffff;\n\tpadding: 20px;\n\tposition: relative;\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: space-between;\n\ttransition: all 0.2s ease-in-out;\n\tmin-height: 450px;\n\t&:hover {\n\t\tbox-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\n\t}\n}\n\n.info-icon-wrapper {\n\tposition: absolute;\n\ttop: 15px;\n\tright: 15px;\n\tz-index: 10;\n\tcursor: pointer;\n\n\tion-icon {\n\t\tfont-size: 24px;\n\t\tcolor: #666666;\n\t}\n}\n\n.image-section {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tmargin-bottom: 5px;\n\tcursor: pointer;\n\taspect-ratio: 9 / 8;\n\twidth: 60%;\n\theight: 100%;\n\tmax-width: 227px;\n\tplace-self: center;\n\n\t.product-img {\n\t\theight: 100%;\n\t\twidth: 100%;\n\t\tobject-fit: contain;\n\t}\n\n\t.placeholder {\n\t\theight: 90%;\n\t\twidth: 90%;\n\t\topacity: 0.8;\n\t}\n}\n\n.content-section {\n\ttext-align: center;\n\tmargin-bottom: 15px;\n\n\t.product-title {\n\t\tfont-family: AppFontMedium;\n\t\tfont-size: 24px;\n\t\tleading-trim: NONE;\n\t\tline-height: 120%;\n\t\tletter-spacing: 0.04em;\n\t\ttext-align: center;\n\t\tvertical-align: middle;\n\t\ttext-transform: uppercase;\n\t\tmargin-bottom: 12px;\n\t}\n\n\t.product-description {\n\t\tfont-family: AppFontAlt;\n\t\tfont-size: 15px;\n\t\tleading-trim: NONE;\n\t\tline-height: 150%;\n\t\tletter-spacing: 0;\n\t\ttext-align: center;\n\t\tvertical-align: middle;\n\n\t\tmargin-bottom: 12px;\n\n\t\tdisplay: -webkit-box;\n\t\t-webkit-line-clamp: 3;\n\t\tline-clamp: 3;\n\t\t-webkit-box-orient: vertical;\n\t\toverflow: hidden;\n\t}\n}\n\n.meta-row {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tgap: 15px;\n\tfont-family: AppFontBold, sans-serif;\n\tfont-size: 14px;\n\ttext-transform: uppercase;\n\tcolor: #000000;\n\tmargin-bottom: 12px;\n\n\t.price {\n\t\tfont-family: AppFontSemiBold;\n\t\tfont-size: 16px;\n\t\tleading-trim: NONE;\n\t\tline-height: 120%;\n\t\tletter-spacing: 0;\n\t\ttext-align: center;\n\t\tvertical-align: middle;\n\t\ttext-transform: uppercase;\n\t}\n\n\t.divider {\n\t\tcolor: #ccc;\n\t\tfont-weight: normal;\n\t}\n\n\t.icons {\n\t\tdisplay: flex;\n\t\tgap: 5px;\n\t\talign-items: center;\n\n\t\tion-icon {\n\t\t\tfont-size: 16px;\n\t\t}\n\t}\n}\n\n.action-buttons {\n\tdisplay: flex;\n\tgap: 12px;\n\tmargin-top: auto;\n\n\tion-button {\n\t\tflex: 1;\n\t\theight: 40px;\n\n\t\t--border-radius: 50px;\n\t\t--box-shadow: none;\n\t\tmargin: 0;\n\n\t\tfont-family: AppFontSemiBold;\n\t\tfont-size: 16px;\n\t\tleading-trim: NONE;\n\t\tline-height: 120%;\n\t\tletter-spacing: 0.04em;\n\t\ttext-align: center;\n\t\tvertical-align: middle;\n\t\ttext-transform: uppercase;\n\n\t\t&.btn-add {\n\t\t\t--background: var(--ion-color-primary); /* Gold */\n\t\t\t--background-hover: var(--ion-color-primary-shade);\n\t\t\t--color: #ffffff;\n\t\t}\n\n\t\t&.btn-customize {\n\t\t\t--background: transparent;\n\t\t\t--color: #000000;\n\t\t\t--border-color: #333333;\n\t\t\t--border-width: 1px;\n\t\t\t--border-style: solid;\n\t\t\tborder-radius: 50px;\n\t\t}\n\t}\n}\n.kcal {\n\tcolor: #666666;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
